import { utils } from 'components/lexemes';
import Localization from 'lib/localization';
export default {
  tab: {
    title() {
      return Localization.get('bumblesite@privacy.rights.tab.title');
    },
    text() {
      return Localization.get('bumblesite@privacy.rights.tab.description');
    },
    contents: {
      title() {
        return Localization.get('bumblesite@privacy.informationDisclosure.tab.contents.title');
      },
      item1() {
        return Localization.get('bumblesite@privacy.rights.tab.contents.item1');
      },
      item2() {
        return Localization.get('bumblesite@privacy.rights.tab.contents.item2');
      },
      item3() {
        return Localization.get('bumblesite@privacy.rights.tab.contents.item3');
      },
      item4() {
        return Localization.get('bumblesite@privacy.rights.tab.contents.item4');
      },
      item5() {
        return Localization.get('bumblesite@privacy.rights.tab.contents.item5');
      },
      item6() {
        return Localization.get('bumblesite@privacy.rights.tab.contents.item6');
      },
      item7() {
        return Localization.get('bumblesite@privacy.rights.tab.contents.item7');
      },
      item8() {
        return Localization.get('bumblesite@privacy.rights.tab.contents.item8');
      },
      item9() {
        return Localization.get('bumblesite@privacy.rights.tab.contents.item9');
      },
      item10() {
        return Localization.get('bumblesite@privacy.rights.tab.contents.item10');
      },
    },
  },
  subsection1: {
    intro() {
      return Localization.get('bumblesite@privacy.rights.subsection1.intro');
    },
    readMore() {
      return Localization.get('bumblesite@privacy.rights.readmore');
    },
    item1: {
      title() {
        return Localization.get('bumblesite@privacy.rights.subsection1.item1.title');
      },
      content() {
        return Localization.get('bumblesite@privacy.rights.subsection1.item1.content');
      },
    },
    item2: {
      title() {
        return Localization.get('bumblesite@privacy.rights.subsection1.item2.title');
      },
      content() {
        return Localization.get('bumblesite@privacy.rights.subsection1.item2.content');
      },
    },
    item3: {
      title() {
        return Localization.get('bumblesite@privacy.rights.subsection1.item3.title');
      },
      content() {
        return Localization.get('bumblesite@privacy.rights.subsection1.item3.content');
      },
    },
    item4: {
      title() {
        return Localization.get('bumblesite@privacy.rights.subsection1.item4.title');
      },
      content() {
        return Localization.get('bumblesite@privacy.rights.subsection1.item4.content');
      },
    },
    item5: {
      title() {
        return Localization.get('bumblesite@privacy.rights.subsection1.item5.title');
      },
      content() {
        return Localization.get('bumblesite@privacy.rights.subsection1.item5.content');
      },
    },
    item6: {
      title() {
        return Localization.get('bumblesite@privacy.rights.subsection1.item6.title');
      },
      content() {
        return Localization.get('bumblesite@privacy.rights.subsection1.item6.content');
      },
    },
    item7: {
      title() {
        return Localization.get('bumblesite@privacy.rights.subsection1.item7.title');
      },
      content() {
        return Localization.get('bumblesite@privacy.rights.subsection1.item7.content', {
          link_contact_us: utils.getLinkMarkerUrl('link_our_contact_information'),
        });
      },
    },
    item8: {
      title() {
        return Localization.get('bumblesite@privacy.rights.subsection1.item8.title');
      },
      content() {
        return Localization.get('bumblesite@privacy.rights.subsection1.item8.content');
      },
    },
  },
  subsection2: {
    goodToKnow: {
      title() {
        return Localization.get('bumblesite@privacy.goodToKnow');
      },
      content() {
        return Localization.get('bumblesite@privacy.rights.subsection2.goodToKnow.content');
      },
    },
    chat1() {
      return Localization.get('bumblesite@privacy.rights.subsection2.chat1', {
        ico_url: utils.getLinkMarkerUrl('ico_url'),
      });
    },
    chat2() {
      return Localization.get('bumblesite@privacy.rights.subsection2.chat2', {
        data_protection_regulator: utils.getLinkMarkerUrl('data_protection_regulator'),
      });
    },
    chat3() {
      return Localization.get('bumblesite@privacy.rights.subsection2.chat3');
    },
    text() {
      return Localization.get('bumblesite@privacy.rights.subsection2.text', {
        feedback_url: utils.getLinkMarkerUrl('feedback_url'),
        link_contact_us: utils.getLinkMarkerUrl('link_our_contact_information'),
      });
    },
  },
  subsection3: {
    title() {
      return Localization.get('bumblesite@privacy.rights.subsection3.title');
    },
    subtitle() {
      return Localization.get('bumblesite@privacy.rights.subsection3.subtitle');
    },
    accordion() {
      return [
        {
          title: Localization.get('bumblesite@privacy.rights.subsection3.item1.title'),
          content: Localization.get('bumblesite@privacy.rights.subsection3.item1.content'),
        },
        {
          title: Localization.get('bumblesite@privacy.rights.subsection3.item2.title'),
          content: Localization.get('bumblesite@privacy.rights.subsection3.item2.content'),
        },
        {
          title: Localization.get('bumblesite@privacy.rights.subsection3.item3.title'),
          content: Localization.get('bumblesite@privacy.rights.subsection3.item3.content'),
        },
        {
          title: Localization.get('bumblesite@privacy.rights.subsection3.item4.title'),
          content: Localization.get('bumblesite@privacy.rights.subsection3.item4.content'),
        },
        {
          title: Localization.get('bumblesite@privacy.rights.subsection3.item5.title'),
          content: Localization.get('bumblesite@privacy.rights.subsection3.item5.content'),
        },
        {
          title: Localization.get('bumblesite@privacy.rights.subsection3.item6.title'),
          content: Localization.get('bumblesite@privacy.rights.subsection3.item6.content'),
        },
      ];
    },
  },
};
